import setToStringTag$1 from '../internals/set-to-string-tag.js';

var setToStringTag = setToStringTag$1; // Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag

setToStringTag(Math, 'Math', true);
